import { axiosInstance } from '@/utils/api'

export interface IWarehouse {
  id: number
  name: string
  code: string
  vendorCode: string
}

export interface IWorkcenter {
  id: number
  name: string
  vendorCode: string
  wipWarehouse: string
}

export interface ISupplier {
  id: number
  name: string
  code: string
}

export interface ITrackingPoint {
  id: number
  name: string
}

export interface IMasterDataResponse {
  warehouses: IWarehouse[]
  workcenters: IWorkcenter[]
  suppliers: ISupplier[]
  trackingPoints: ITrackingPoint[]
}

export async function getMasterData(): Promise<IMasterDataResponse> {
  const response = await axiosInstance.get('/master-data')
  return response.data
}

export type TImportHistoryStatus = 'unknown' | 'request' | 'processing' | 'success' | 'failed'

export interface IImportHistoryDetail {
  id: number
  importHistoryId: number
  module: string
  createdIds?: string
  updatedIds?: string
  deletedIds?: string
  errorInfo?: string
}

export interface IImportHistory {
  id: number
  fileName: string
  fileUrl?: string
  status: TImportHistoryStatus
  errorMessage?: string
  createdUserId?: string
  userFullName?: string
  createdDateTime?: string
  updatedDateTime?: string
  details: IImportHistoryDetail[]
}

export async function getLatestImportHistory(): Promise<IImportHistory | null> {
  const response = await axiosInstance.get('/import/master-data/latest')
  return response.data ?? null
}
